import * as React from 'react';
import { Instance } from 'mobx-state-tree';
import { inject, observer } from 'mobx-react';
import * as classnames from 'classnames';

import { pushToEventDetail } from '../../liveRouting';
import { DesktopLiveEventListStore, IDesktopLiveEventListStore, ProgressStateModel, evalFooterVisibility } from 'eTip--common';
import { ApplicationStoreKey, ApplicationStore } from '../../liveStores';
import { EventListDetailContainer } from '../liveEventDetail/eventListDetailContainer';
import { LiveEventStore } from '../../models/live/liveEvent';
import { ILiveCategoryStore } from '../../models/live/liveCategory';
import { FooterContainer } from '../footer/footerContainer';
import { LiveEventListItemContainer } from './liveEventListItemContainer';
import { SportFilterAllAsString, SportFilterMatchTrackersAsString, SportFilterVideosAsString, SportFilterMatchTrackers, SportFilterVideos } from '../../models/live/liveEventList';

import { Row, Col, ProgressContent, NoResultsEmptyList } from 'common--design-library';
import { CategoryWrapper, ISportItem, SimpleBarWrapper, SportSelection } from 'desktop--design-library';

import { translation } from 'easit--localization';

export interface IEventListProps {
    applicationStore?: Instance<typeof ApplicationStore>
}

interface ISportItemWithSequence extends ISportItem {
    sequence: number;
}

@inject(ApplicationStoreKey)
@observer
export class EventListRoute extends React.Component<IEventListProps> {
    get screenInfoStore() {
        return this.props.applicationStore.screenInfo;
    }

    componentWillMount() {
        this.props.applicationStore.setCanShowLeftColumn(false);

        if (!this.screenInfoStore.isXxlDown) {  //same in liveApp.tsx after init load
            this.store.checkAndOpenDetail();
        }

        this.store.updateIsExpandedInCategoriesOnList();
    }

    componentWillUnmount() {
        this.store.hideDetail();
    }

    private renderTelemetryContext: number;

    componentWillUpdate(_prevProps: IEventListProps) {
        this.renderTelemetryContext = this.store.entryPageRenderTelemetry.start();

        if (this.props.applicationStore.screenInfo.isXxlDown) {
            if (this.store.isDetailShown && this.store.isDetailShownAsDefault) {
                this.store.hideDetail();
            }
        }
        else {
            if (this.store.state === ProgressStateModel.Success && !this.store.isDetailShown) {
                this.store.checkAndOpenDetail();
            }
        }
    }

    componentDidUpdate() {  //TODO it does not call this for the first time
        this.props.applicationStore.entryPageGlobalRenderTelemetry.finish();
        this.store.entryPageRenderTelemetry.finish(this.renderTelemetryContext);
    }

    openDetail(eventId: number) {
        if (this.screenInfoStore.isXxlDown) {
            this.store.toggleDetail(eventId);
        }
        else {
            if (this.store.isDetailShown && this.store.detail.id !== eventId) {
                this.store.showDetail(eventId, true);
            }
        }
    }
    get store() {
        return this.props.applicationStore.events;
    }

    renderCategories(categories: ILiveCategoryStore[], eventCount: number, isFavorites: boolean) {
        let isAllSelected = this.store.sportFilter.has(SportFilterAllAsString) && this.store.sportFilter.get(SportFilterAllAsString).isSelected;
        let isMatchTrackerSelected = this.store.sportFilter.has(SportFilterMatchTrackersAsString) && this.store.sportFilter.get(SportFilterMatchTrackersAsString).isSelected;
        let isVideosSelected = this.store.sportFilter.has(SportFilterVideosAsString) && this.store.sportFilter.get(SportFilterVideosAsString).isSelected;

        let filteredCats: ILiveCategoryStore[];

        if (this.store.canFilterVideoAndMTWithSport) {
            let isSomeSportSelected = categories.some(cat => this.store.sportFilter.get(cat.id.toString()).isSelected);
            if (isAllSelected) {
                filteredCats = categories;
            } else {
                if (isMatchTrackerSelected && isVideosSelected) {
                    filteredCats = isSomeSportSelected ?
                        categories.filter(cat => (cat.hasMatchTrackerEvent && cat.hasVideoEvent && (this.store.sportFilter.has(cat.id.toString()) && this.store.sportFilter.get(cat.id.toString()).isSelected)))
                        : categories.filter(cat => cat.hasMatchTrackerEvent && cat.hasVideoEvent);
                }
                else if (isMatchTrackerSelected) {
                    filteredCats = isSomeSportSelected ?
                        categories.filter(cat => (cat.hasMatchTrackerEvent && (this.store.sportFilter.has(cat.id.toString()) && this.store.sportFilter.get(cat.id.toString()).isSelected))) :
                        categories.filter(cat => cat.hasMatchTrackerEvent);
                } else if (isVideosSelected) {

                    filteredCats = isSomeSportSelected ?
                        categories.filter(cat => (cat.hasVideoEvent && (this.store.sportFilter.has(cat.id.toString()) && this.store.sportFilter.get(cat.id.toString()).isSelected))) :
                        categories.filter(cat => cat.hasVideoEvent);
                } else {
                    filteredCats = categories.filter(cat => this.store.sportFilter.has(cat.id.toString()) && this.store.sportFilter.get(cat.id.toString()).isSelected);
                }
            }

            if (filteredCats.length == 0 && !isFavorites) {
                return <NoResultsEmptyList key={'no_results'} message={translation().no_results} />
            }
        } else {
            if (isAllSelected) {
                filteredCats = categories;
            } else if (isMatchTrackerSelected) {
                filteredCats = categories.filter(cat => cat.hasMatchTrackerEvent);
            } else if (isVideosSelected) {
                filteredCats = categories.filter(cat => cat.hasVideoEvent);
            } else {
                filteredCats = categories.filter(cat => (this.store.sportFilter.has(cat.id.toString()) && this.store.sportFilter.get(cat.id.toString()).isSelected));
            }
        }

        return <>
            <div className="live-events-group-header">{isFavorites ? translation().desktopLive_FavoriteEvents : translation().desktopLive_OpenEvents} ({eventCount})</div>
            {filteredCats.map((category: ILiveCategoryStore) => {
                let previousCategoryPath: string = null;
                let filteredEvents: IDesktopLiveEventListStore[];
                if (isMatchTrackerSelected && isVideosSelected) {
                    filteredEvents = category.events.filter(evt => evt.matchTracker && evt.liveStream);
                } else if (isMatchTrackerSelected) {
                    filteredEvents = category.events.filter(evt => evt.matchTracker);
                } else if (isVideosSelected) {
                    filteredEvents = category.events.filter(evt => evt.liveStream);
                } else {
                    filteredEvents = category.events;
                }
                return (
                    <CategoryWrapper
                        key={category.id /* ! also favorites */}
                        graphicsPresentationId={category.graphicsPresentationId}
                        sportName={category.name}
                        isExpanded={category.isExpandedInLeftMenu}
                        onExpand={() => {
                            category.toggleIsExpandedInLeftMenu();
                            this.store.storeCollapsedCategory(category.id, category.isExpandedInLeftMenu);
                        }}
                        gameGroupsToFilter={category.shownGameGroups}
                        selectedGameGroupId={category.shownGameGroupId}
                        setSelectedGameGroup={(groupId: string) => { category.setSelectedGameGroupId(groupId) }}
                        roleForTest="sport-categories__item"
                        canCollapseSport={this.props.applicationStore.settingsProvider.canLiveEventsListCollapseSport}
                    >
                        <div
                            className={classnames('event-table', { 'detail-opened': this.store.isDetailShown /* TODOHL is relevant? */ })}
                            key={`t_${category.id}`}
                        >
                            {filteredEvents.map((evt) => {
                                let canShowCategoryPath = previousCategoryPath !== evt.categoryPath;
                                previousCategoryPath = evt.categoryPath;
                                return this.renderRow(`r_${evt.id}`, evt, category, this.store.detail, canShowCategoryPath);
                            })}
                        </div>
                    </CategoryWrapper>
                );
            })
            }
        </>
    }

    renderSportFilter() {
        let filters: ISportItemWithSequence[] = [];
        let selectedSports: number[] = [];
        this.store.sportFilter.forEach(filterItem => {
            filters.push({ categoryId: filterItem.id, graphicsPresentationId: filterItem.graphicsPresentationId, label: filterItem.label, sequence: filterItem.sequence })
            if (filterItem.isSelected) {
                selectedSports.push(filterItem.id);
            }
        });
        filters.sort((a, b) => { return a.sequence < b.sequence ? -1 : a.sequence > b.sequence ? 1 : 0 });

        return <SportSelection
            sports={filters}
            selectedSports={selectedSports}
            selectSport={(sportCategoryId: number) => {
                this.store.toggleSportFilterBySportCategoryId(sportCategoryId);
            }}
            favoritesCategoryId={null}
            videosCategoryId={SportFilterVideos}
            matchTrackersCategoryId={SportFilterMatchTrackers}
        />
    }

    render() {
        return (
            <React.Fragment>
                <Row noGutters className="h-100">
                    <Col className={"col-xxl-16 h-100"}>
                        <SimpleBarWrapper id={'event-list'} className="scroll-container" forceVisible={true} scrollToTop>
                            <ProgressContent state={this.store.state} >
                                <div className="px-gutter" data-test-role="event-list">
                                    {this.store.categories.length > 0 || this.store.favoriteCats.length > 0 ?
                                        <>
                                            {
                                                this.renderSportFilter()
                                            }
                                            {
                                                this.store.favoriteCats.length > 0 &&
                                                this.renderCategories(this.store.favoriteCats, this.store.favoritesEventCount, true)
                                            }
                                            {
                                                this.renderCategories(this.store.categories, this.store.categoriesEventCount, false)
                                            }</>
                                        : (
                                            <NoResultsEmptyList key={'no_results'} message={translation().no_results} />
                                        )}
                                </div>
                                <div className="m-3">{translation().live_WarrantyInfo}</div>
                            </ProgressContent>
                            <FooterContainer canShow={evalFooterVisibility(this.store.state)} />
                        </SimpleBarWrapper>
                    </Col>
                    {!this.screenInfoStore.isXxlDown &&
                        this.store.isDetailShown && (
                            <Col xs={8} className="h-100">
                                <SimpleBarWrapper className="scroll-container" forceVisible={true} scrollToTop>
                                    <div className="px-gutter">
                                        {this.renderDetail(true)}
                                    </div>
                                </SimpleBarWrapper>
                            </Col>
                        )}
                </Row>
            </React.Fragment >
        );
    }

    private renderRow(key: string, rowEvent: Instance<typeof DesktopLiveEventListStore>, category: ILiveCategoryStore, detailEvent: Instance<typeof LiveEventStore>, canShowCategoryPath: boolean) {
        let hasMatchTracker = this.props.applicationStore.events.eventsWithMatchTracker.has(rowEvent.id);
        return (
            <React.Fragment key={key}>
                {canShowCategoryPath && <div className="live-eventlist-item-cat">{rowEvent.categoryPath}</div>}
                <LiveEventListItemContainer
                    eventApiData={rowEvent}
                    ticketWrapper={this.props.applicationStore.ticketWrapper}
                    onSetFavorite={(event: IDesktopLiveEventListStore, value: boolean) => { this.props.applicationStore.setEventIsFavorite(event.id, value); }}
                    canShowSportIcon={false}
                    isFavorite={category.isFavorite}
                    onGoToDetail={(id: number) => { pushToEventDetail(id); }}
                    onShowDetail={(id: number) => {
                        this.openDetail(id);
                        if (__IsMTSTipos__ && hasMatchTracker) {
                            this.props.applicationStore.events.rightSideStreamWrapper.open(this.props.applicationStore.events.eventsWithMatchTracker.get(id))
                        }
                    }}
                    isDetailOpened={this.store.isDetailShown && rowEvent.id === detailEvent.id}
                    isDetailOpenedBelow={this.screenInfoStore.isXxlDown}
                    gameAndDetailProvider={(eventApiData: Instance<typeof DesktopLiveEventListStore>) => eventApiData.gameAndDetailForGroup(category.shownGameGroupId)}
                    isMatchTracker={hasMatchTracker}
                    matchTrackerClick={hasMatchTracker ? () => { this.props.applicationStore.events.rightSideStreamWrapper.open(this.props.applicationStore.events.eventsWithMatchTracker.get(rowEvent.id)); } : null}
                    isLiveStream={!!rowEvent.liveStream}
                    liveStreamClick={() => { /*this.openDetail(rowEvent.id);*/ pushToEventDetail(rowEvent.id, false, true); }}
                    isLiveInPrematch={false}
                    screenInfo={this.props.applicationStore.screenInfo}
                />
                {this.screenInfoStore.isXxlDown && this.store.isDetailShown &&
                    rowEvent.id === detailEvent.id &&
                    <Row><Col xs={24}>{this.renderDetail(false)}</Col></Row>
                }
            </React.Fragment>
        );
    }

    renderDetail(withHeader: boolean) {
        const hasMatchTracker = this.props.applicationStore.events.eventsWithMatchTracker.has(this.store.detail.id);
        return (
            <EventListDetailContainer
                detail={this.store.detail}
                ticketWrapper={this.props.applicationStore.ticketWrapper}
                showHeader={withHeader}
                isMatchTracker={hasMatchTracker}
                canShowLiveEventDetailGroupTabs={this.props.applicationStore.settingsProvider.canShowLiveEventDetailGroupTabs}
                matchTrackerClick={hasMatchTracker ? () => { this.props.applicationStore.events.rightSideStreamWrapper.open(this.props.applicationStore.events.eventsWithMatchTracker.get(this.store.detail.id)) } : null}
                canClearStoreOnUmount={true}
            />
        );
    }
}
